import { clearPhotoTextZone } from '../../../utils';
import { ResetTextData } from '../card-face-types';

export const closeResetTextModal = (setResetTextModalOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
  setResetTextModalOpen(false);
};

export const confirmResetText = (
  resetTextData: ResetTextData,
  setResetTextModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  clearPhotoTextZone(resetTextData.canvas, resetTextData.zoneName);
  setResetTextModalOpen(false);
};
